import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonCTAProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function ButtonCTA({
  children,
  onClick,
  className = ''
}: ButtonCTAProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    window.location.href = 'https://www.plenaahora.com/cart/54440324366628:1';
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 bg-brand-terracotta px-8 py-4 text-lg font-semibold text-white transition-colors hover:bg-brand-terracotta-dark rounded-full shadow-lg hover:shadow-xl ${className}`} data-id="element-20">
      <span data-id="element-21">{children}</span>
      <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-22" />
    </motion.button>;
}